import { useSettings } from '@wu/widget-core';
import { isFacebook } from '../../../constants';

const IMG_PROXY = 'https://phosphor.utils.elfsightcdn.com/';

const getImageURL = (src: string) => {
  if (!src) return '';

  if (/https?:\/\//.test(src)) {
    const url = new URL(IMG_PROXY);
    url.searchParams.set('url', src);

    return url.toString();
  }

  return src;
};

export const useSettingsFromFacebook = () => {
  // @TODO add absent type
  const { page, facebookPage = {}, infoFromFacebook } = useSettings();

  if (!infoFromFacebook || !isFacebook) {
    return {};
  }

  const responseFacebook = page?.data || facebookPage?.data;
  if (responseFacebook) {
    const { name, pictureURL } = responseFacebook;

    return { name, image: getImageURL(pictureURL) };
  }

  const { name, picture } = page || facebookPage;

  return { name, image: getImageURL(picture?.data?.url) };
};
